import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=b1c1b418&scoped=true"
import script from "./cabinet.vue?vue&type=script&lang=ts"
export * from "./cabinet.vue?vue&type=script&lang=ts"
import style0 from "./cabinet.vue?vue&type=style&index=0&id=b1c1b418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c1b418",
  null
  
)

export default component.exports